export const unreadCountScreenReaderOnlyText = "Oq8bDc";
export default {unreadCountScreenReaderOnlyText};